<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="specialApplication.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="1200px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          :model="specialApplication"
          :rules="ruleValidate"
          class="form"
          label-width="150px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="出厂编号">
              <el-input v-model="specialApplication.factorNo" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="关联单号">
              <el-input v-model="specialApplication.relevanceNo" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="特批来源">
              <el-select v-model="specialApplication.applyType" clearable placeholder="请选择">
                <el-option
                    v-for="item in specialApplicationTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="申请人">
              <el-input v-model="specialApplication.creatorName" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="申请部门">
              <el-input v-model="specialApplication.applicantDepartment" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系方式">
              <el-input v-model="specialApplication.mobile" placeholder="请输入"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="物料名称">
              <el-input v-model="specialApplication.materialName" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="物料编号">
              <el-input v-model="specialApplication.materialNo" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="数量">
              <el-input v-model="specialApplication.quantity" placeholder="请输入"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="特批原因">
              <el-input v-model="specialApplication.specialReason" type="textarea" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="造成影响">
              <el-select v-model="specialApplication.defectResult" clearable placeholder="请选择">
                <el-option
                    v-for="item in defectResults"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="对风险的措施">
              <el-input v-model="specialApplication.measures" type="textarea" placeholder="请输入"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注">
          <el-input v-model="specialApplication.note" type="textarea" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="选择特批部门">
          <el-checkbox-group v-model="specialApplication.specialDepartmentList">
            <el-checkbox-button v-for="item in specialDepartmentList" :key="item" :label="item">{{item}}</el-checkbox-button>
          </el-checkbox-group>
        </el-form-item>

        <div>
          <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">订单附件</div>
          <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;margin: 10px 0 10px 0">
            <el-upload
                :action="actionUrl"
                :on-success="handleSuccess"
                :on-remove="handleRemove"
                :on-error="handlerError"
                :file-list="files"
                :show-file-list="false">
              <el-button size="small" type="primary" style="margin: 0 5px 0 0">添加附件</el-button>
            </el-upload>
          </div>
          <el-table
              v-if="specialApplication.attachments"
              ref="payData1"
              :data="specialApplication.attachments">
            <el-table-column type="index" align="center" label="行号"/>
            <el-table-column prop="fileName" align="center" label="附件描述">
              <template slot-scope="scope">
                <el-input v-model="scope.row.fileName" class="tabInput" style="width: 400px;margin: 0 auto;text-align: center"/>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="60" class-name="vm-table_operate">
              <template slot-scope="scope">
                <el-button type="danger" @click="fileDelete(scope.row,scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "@/util/constant";
  import loginUtil from "@/util/loginUtil";
  export default {
    name:"SpecialApplicationEdit",
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        constant,
        specialApplicationTypes:constant.toSelect(constant.specialApplicationType),
        defectResults:constant.toSelect(constant.defectResult),
        files: [],
        specialDepartmentList: ["技术部", "采购部", "客户质量部", " 供应商质量部", "工厂质量部"],
        selection: [],
        index: [],
        actionUrl: window.config.basicServerHttpUrl + "file/upload",
        specialApplication: {
          pkid: "",
          billNo: "",
          applicantDepartment: "",
          creatorName: loginUtil.getName(),
          applyType: "",
          factorNo: "",
          materialName: "",
          materialNo: "",
          quantity: "",
          specialReason: "",
          measures: "",
          relevanceNo: "",
          defectResults: "",
          isJS: false,
          note: "",
          attachments:[],
          specialDepartmentList:[],
        },
        ruleValidate: {
          // specialApplicationNO: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.specialApplication.pkid = id;
        this.dialogVisible = true;
        if(id>0) {
          this.getData();
        }
      },
      handlerError(err, file, fileList) {
        console.log(file);
        console.log(fileList);
        alert(err);
      },
      //附件表页面删除
      fileDelete(row, index) {
        this.specialApplication.attachments.splice(index, 1);
      },
      handleSuccess(response, file, fileList) {
        console.log(this.specialApplication);
        file.path = response;
        this.files = fileList;
        let object ={
          fileName:file.path.originalName,
          filePath:file.path.fullPath,
        };
        this.specialApplication.attachments.push(object);
      },
      handleRemove(file, fileList) {
        this.files = fileList;
      },
      getData() {
        this.$http
          .get("basic", `specialApplications/${this.specialApplication.pkid}`)
          .then(resp => {
            this.specialApplication = resp;
          });
      },
      handleSubmit() {
        console.log(this.specialApplication.specialDepartmentList);
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            // this.specialApplication.isSubmit = false;
            if(this.specialApplication.pkid>0) {
              this.$http
                .put("basic", "specialApplications", this.specialApplication)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }else {
              this.$http
                .post("basic", "specialApplications", this.specialApplication)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
